import { SignInMethodOption, SignInMethodType, SignInVerification } from '../../../../entities/SignInMethod';

export default class CodeMethodStepModel {
  static readonly ERROR_MESSAGE = 'Não foi possível enviar o código. Tente novamente.';

  static listOptions(verifyData: SignInVerification): SignInMethodOption[] {
    const options: SignInMethodOption[] = [
      { type: SignInMethodType.PHONE, label: 'WhatsApp', value: verifyData.whatsapp },
      { type: SignInMethodType.EMAIL, label: 'E-mail', value: verifyData.email }
    ];
    return options.filter(option => !!option.value);
  }
}
